import { NgModule } from '@angular/core';
import { ActionsComponent } from './actions.component';
import { MessageModule } from 'primeng/message';
import { SharedModule } from '@shared/shared.module';
import { PaginatorModule } from 'primeng/paginator';
import { INavigationModule } from '@devinforius/i-navigation';
import { ActionsRoutingModule } from './actions-routing.module';
import { InputTextareaModule } from 'primeng/inputtextarea';

@NgModule({
  imports: [SharedModule, MessageModule, PaginatorModule, INavigationModule, ActionsRoutingModule, InputTextareaModule],
  declarations: [ActionsComponent],
  exports: [ActionsComponent],
})
export class ActionsModule {}
